import React, { FC, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Input, Button, Form } from 'antd';
import * as _ from 'lodash';
import { actions as appointmentActions } from 'store/appointment';
import StoreState from 'models/store';
import { formRules } from 'helpers/formUtils';
import AppointmentCard from '../../AppointmentCard/AppointmentCard';

const DrugInUse: FC<any> = props => {
  const appointmentReducer = useSelector(
    (state: StoreState) => state.appointment,
  );
  const [isEdit, setIsEdit] = useState<any>();
  const [isAdd, setIsAdd] = useState<any>(false);
  const [i, setI] = useState<any>();
  const [isSubmit, setIsSubmit] = useState(false);
  const { initValues, dataProps, isEditAvailability } = props;
  const dispatch = useDispatch();

  const arrDrugsPresent = dataProps?.detail?.encounters[0]?.obs?.filter(item =>
    item?.display?.includes('DRUGS ARE IN USE'),
  );

  const originTime = new Date();
  const handleEdit = _.debounce(key => {
    setIsEdit(true);
    setI(key);
  }, 50);

  const handleCancel = _.debounce(key => {
    setIsEdit(false);
    setI(key);
  }, 50);

  // const handleSave = _.debounce(key => {
  //   setIsEdit(false);
  //   setI(key);
  // }, 50);

  const onEdit = values => {
    const { drugInUse } = values;
    const uuidDrugsPresent = arrDrugsPresent[i]?.uuid;
    const paramsEditDrugsPresent = {
      value: drugInUse,
    };
    dispatch(
      appointmentActions.handleEditDrugsPresent({
        uuidDrugsPresent,
        paramsEditDrugsPresent,
      }),
    );
    setIsEdit(false);
  };

  const onFinish = values => {
    setIsSubmit(true);
    const { drugInUse } = values;
    const paramsCreateDrugsPresent = {
      value: drugInUse,
      concept: 'c4e14c9b-6a71-4ae3-afa1-3ce34ba89f34',
      obsDatetime: originTime?.toISOString(),
      person: dataProps?.detail?.uuidPerson,
      encounter: dataProps?.detail?.encounters[0]?.uuid,
    };
    dispatch(
      appointmentActions.handleCreateDrugsPresent(paramsCreateDrugsPresent),
    );
  };

  useEffect(() => {
    if (
      isSubmit === true &&
      appointmentReducer?.isAddCreateDrugsPresent === true
    ) {
      setIsAdd(false);
    }
  }, [appointmentReducer?.isAddCreateDrugsPresent]);

  return (
    <div className="drug-in-use">
      {initValues?.length > 0 ? (
        <AppointmentCard title="Thuốc đang sử dụng">
          {initValues?.map((item, key) => {
            return (
              <Row className="row-1" key={key}>
                <Col xs={24}>
                  <div className="anamnesis-section">
                    <Form onFinish={onEdit}>
                      <div className="anamnesis-section__title">
                        <div>
                          <span> </span>
                        </div>
                        <div className="btn-edit">
                          {isEditAvailability &&
                            (isEdit && key === i ? (
                              <>
                                <Button
                                  size="middle"
                                  onClick={() => handleCancel(key)}
                                >
                                  Hủy
                                </Button>{' '}
                                <Button
                                  size="middle"
                                  htmlType="submit"
                                  // onClick={() => handleSave(key)}
                                >
                                  Lưu
                                </Button>
                              </>
                            ) : (
                              <Button
                                onClick={() => handleEdit(key)}
                                size="middle"
                              >
                                Sửa
                              </Button>
                            ))}
                        </div>
                      </div>
                      <div className="anamnesis-section__content">
                        <div className="anamnesis-section__content_inside">
                          {isEdit && key === i ? (
                            <Form.Item
                              name="drugInUse"
                              preserve={false}
                              rules={formRules}
                              initialValue={item}
                            >
                              <Input autoComplete="off" />
                            </Form.Item>
                          ) : (
                            <span className="text-have-color-#555555">
                              {item}
                            </span>
                          )}
                        </div>
                      </div>
                    </Form>
                  </div>
                </Col>
              </Row>
            );
          })}
        </AppointmentCard>
      ) : (
        <Row className="row-1">
          <Col xs={24}>
            <div className="anamnesis-section">
              <div className="anamnesis-section__title">
                <div>
                  <span>Thuốc đang sử dụng</span>
                </div>
              </div>
              <div className="no-content">
                <span className="no-content__text">Chưa có thông tin</span>
              </div>
            </div>
          </Col>
        </Row>
      )}

      {isEditAvailability && (
        <div className="anamnesis-add-container">
          {isAdd ? (
            <Form onFinish={onFinish}>
              <div className="anamnesis-input-add">
                <Form.Item name="drugInUse" rules={formRules}>
                  <Input
                    size="large"
                    placeholder="Thêm thông tin thuốc đang sử dụng"
                    ref={input => input && input.focus()}
                  />
                </Form.Item>
              </div>
              <div className="anamnesis-action-add">
                <div className="btn-ok">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={appointmentReducer?.isLoadingCreateDrugsPresent}
                  >
                    Lưu
                  </Button>
                </div>
                <div className="btn-cancel">
                  <a
                    className="no-underline"
                    href="#"
                    onClick={() => setIsAdd(!isAdd)}
                  >
                    <span>Hủy</span>
                  </a>
                </div>
              </div>
            </Form>
          ) : (
            <div>
              <Button
                className="rounded-md"
                type="primary"
                onClick={() => setIsAdd(!isAdd)}
              >
                Thêm thông tin
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DrugInUse;
